<template>
  <!-- V1 Bölümü (Dokunulmadı) -->
  <section
    v-if="variants.v1 === variant"
    class="tabs -type-2 !tw-block"
  >
    <div class="tabs__test">
      <div class="container">
        <div class="row y-gap-15 justify-between items-end">
          <div class="col-lg-6">
            <div v-html="vars.titleHtml"></div>
          </div>

          <div class="col-auto">
            <div class="tabs__nav d-flex">
              <button
                class="button -outline-white size-80 text-20 text-white -prev js-tabsSlider-prev !tw-rounded-full"
                style="border: 1px solid #fff"
                tabindex="-1"
                aria-label="Previous slide"
              >
                <i class="icon-left-arrow"></i>
              </button>
              <button
                class="button -outline-white size-80 text-20 text-white -next ml-20 js-tabsSlider-next !tw-rounded-full"
                style="border: 1px solid #fff"
                tabindex="0"
                aria-label="Next slide"
              >
                <i class="icon-right-arrow"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="slider js-tabsSlider">
      <div class="swiper-wrapper">
        <div
          v-for="(label, idx) in labels"
          :key="idx"
          class="swiper-slide"
          role="group"
          :aria-label="`${idx + 1} / ${labels.length}`"
        >
          <div class="container">
            <div class="row">
              <div class="col-auto">
                <div class="tabs__content">
                  <div class="tabs__bg">
                    <img :src="String(label.photo || '')" alt="image" />
                  </div>

                  <h4 style="color: var(--c-text_primary)">{{ label.title }}</h4>
                <div
  class="description-text tw-flex tw-flex-col tw-space-y-4 pt-60 md:pt-30 tw-max-w-[800px]"
  style="color: white !important"
>
  <p>{{ label.description }}</p>
  <p>{{ label.description2 }}</p>
  <p>{{ label.description3 }}</p>
</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- V2 Bölümü (Mobilde oklar başlığın altına gelecek şekilde güncellendi) -->
  <section
    v-if="variants.v2 === variant"
    class="tabs -type-2 !tw-block"
    :style="`background-color: var(--c-${vars.backgroundColor}) !important;`"
  >
    <BlockSymbol
      :position-text="String(vars?.blockPositionText || '')"
      :block-color="String(vars?.blockColor || '')"
      :block-opacity="Number(vars?.blockOpacityNumber || 1)"
      :company-key="company?.company_key"
    />

    <div
      class="tabs__test"
      
    >
      <div class="container">
        <!-- Burada mobilde flex-col → lg:flex-row -->
        <div class="row y-gap-15 justify-between flex-col items-start lg:flex-row lg:items-end">
          <div class="col-lg-6">
            <div class="text-62 md:text-38 fw-500" v-html="vars.titleHtml"></div>
          </div>

          <!-- mt-4 ile mobilde boşluk, lg:mt-0 ile büyük ekranda sıfırlama -->
          <div class="col-auto mt-4 lg:mt-0">
            <div class="tabs__nav d-flex">
              <button
                class="button -outline-white size-80 text-20 text-white -prev js-tabsSlider-prev !tw-rounded-full"
                style="border: 1px solid #fff"
                tabindex="-1"
                aria-label="Previous slide"
              >
                <i class="icon-left-arrow"></i>
              </button>
              <button
                class="button -outline-white size-80 text-20 text-white -next ml-20 js-tabsSlider-next !tw-rounded-full"
                style="border: 1px solid #fff"
                tabindex="0"
                aria-label="Next slide"
              >
                <i class="icon-right-arrow"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="slider js-tabsSlider">
      <div class="swiper-wrapper">
        <div
          v-for="(label, idx) in labels"
          :key="idx"
          class="swiper-slide"
          role="group"
          :aria-label="`${idx + 1} / ${labels.length}`"
        >
          <div class="container">
            <div class="row">
              <div class="col-auto">
                <div
                  class="tabs__content"
                  :style="`color: var(--${vars.textColor}) !important;`"
                >
                  <!-- Burada görsel yoksa boş bırakılıyor -->
                  <div></div>

                  <h4>{{ label.title }}</h4>
                  <p
                    :style="`color: var(--${vars.textColor}) !important;`"
                    class="pt-60 md:pt-30 tw-max-w-[800px]"
                  >
                    {{ label.description }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- V3: Tab Slider -->
  <section 
    v-if="variants.v3 === variant" 
    class="layout-pt-lg layout-pb-lg"
  >
    <!-- Background Base -->
    <div class="tw-absolute tw-inset-0 tw-bg-black"></div>
    
    <!-- Background Images with Cross Fade -->
    <div 
      v-for="(tab, index) in tabs" 
      :key="index"
      class="tw-absolute tw-inset-0 tw-bg-cover tw-bg-center tw-bg-no-repeat tw-transition-opacity tw-duration-500 tw-ease-in-out"
      :class="{ 'tw-opacity-100': activeIndex === index, 'tw-opacity-0': activeIndex !== index }"
      :style="`background-image: url('${tab.background || tab.backgroundImage || ''}')`"
    >
      <!-- Overlay -->
      <div class="tw-absolute tw-inset-0 tw-bg-black tw-bg-opacity-40"></div>
    </div>

    <!-- Content Container -->
    <div class="tw-relative tw-z-10 tw-container tw-mx-auto tw-px-4 tw-py-16 tw-flex tw-flex-col">
      <!-- Title -->
      <div class="tw-mb-12">
        <h2 class="tw-text-white tw-text-4xl md:tw-text-6xl tw-font-medium tw-tracking-wide">
          {{ vars.titleText }}
        </h2>
      </div>

      <!-- Navigation and Controls -->
      <div class="tw-flex tw-justify-between tw-items-center tw-mb-8">
        <!-- Tab Navigation -->
        <div class="tw-flex tw-space-x-8">
          <button
            v-for="(tab, index) in tabs"
            :key="index"
            @click="goToTab(index)"
            :class="[
              'tw-text-white tw-text-lg tw-font-medium tw-pb-2 tw-border-b-2 tw-transition-all tw-duration-300',
              activeIndex === index 
                ? 'tw-border-white tw-opacity-100' 
                : 'tw-border-transparent tw-opacity-60 hover:tw-opacity-80'
            ]"
          >
            STEP {{ index + 1 }}
          </button>
        </div>

        <!-- Arrow Navigation -->
        <div class="tw-flex tw-space-x-4">
          <button class="sliderNav -prev js-prev n-link !tw-border-white !tw-bg-transparent tw-border" @click="previousTab">
            <i class="icon-left-arrow !tw-text-white"></i>
          </button>
          <button class="sliderNav -next ml-20 js-next n-link !tw-border-white !tw-bg-transparent tw-border" @click="nextTab">
            <i class="icon-right-arrow !tw-text-white"></i>
          </button>
        </div>
      </div>

              <!-- Content Area -->
        <div>
          <div class="tw-max-w-2xl">
            <transition name="content-slide" mode="out-in">
              <div 
                class="tw-text-white tw-text-lg tw-leading-relaxed"
                :key="activeIndex"
              >
                {{ tabs[activeIndex]?.description || '' }}
              </div>
            </transition>
          </div>
        </div>
    </div>
  </section>
</template>

<script lang="ts">
import {mapState} from 'pinia';
import { defineComponent } from 'vue'
import { ComponentMixin } from '~/mixins/component.mixin'
import BlockSymbol from '~/components/common/BlockSymbol.vue'
import { useWebsiteStore } from '~/units/website/store';

export default defineComponent({
  name: 'Theme7StorySlider',
  mixins: [ComponentMixin],

  components: {
    BlockSymbol,
  },

  data() {
    return {
      activeIndex: 0,
      swiperInstance: null,
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
      },
    }
  },

  computed: {
    ...mapState(useWebsiteStore, ['company']),
    labels() {
      return this.groupedVariables.labels
    },
    descriptions() {
      return this.groupedVariables.descriptions
    },
    tabs() {
      return this.groupedVariables.tabs
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.initSwiper()
    })
  },

  updated() {
    this.$nextTick(() => {
      this.initSwiper()
    })
  },

  methods: {
    initSwiper() {
      // Mevcut Swiper instance'ını destroy et
      if (this.swiperInstance) {
        (this.swiperInstance as any).destroy(true, true)
        this.swiperInstance = null
      }
      
      // Yeni Swiper'ı başlat
      setTimeout(() => {
        if (typeof window !== 'undefined' && (window as any).tabsSlider) {
          this.swiperInstance = (window as any).tabsSlider()
        }
      }, 100)
    },
    goTo(index: number) {
      this.activeIndex = index
    },
    onViewMore(item: any) {
      this.$emit('view-more', item)
    },
    goToTab(index: number) {
      this.activeIndex = index
    },
    previousTab() {
      this.activeIndex = this.activeIndex === 0 ? this.tabs.length - 1 : this.activeIndex - 1
    },
    nextTab() {
      this.activeIndex = this.activeIndex === this.tabs.length - 1 ? 0 : this.activeIndex + 1
    },

  },
})
</script>

<style scoped>
.description-text {
  color: white !important;
  text-fill-color: white !important;
  -webkit-text-fill-color: white !important;
}

.block {
  font-size: 32em !important;
  font-weight: 900 !important;
  color: var(--c-secondary);
  line-height: 0.8;
  z-index: -1;
  margin: 35px;
  padding: 0;
  position: absolute;
}

/* Background Images are now handled via Tailwind opacity classes */

/* Content Slide Transitions */
.content-slide-enter-active,
.content-slide-leave-active {
  transition: all 0.3s ease-in-out;
}

.content-slide-enter-from {
  opacity: 0;
  transform: translateX(30px);
}

.content-slide-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}

.content-slide-enter-to,
.content-slide-leave-from {
  opacity: 1;
  transform: translateX(0);
}

/* Tab Button Smooth Transitions */
.tw-transition-all {
  transition: all 0.2s ease-in-out !important;
}

/* Tab Underline Animation */
.tw-border-b-2 {
  position: relative;
  overflow: hidden;
}

.tw-border-b-2::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: white;
  transform: translateX(-100%);
  transition: transform 0.2s ease-in-out;
}

.tw-border-white::after {
  transform: translateX(0);
}
</style>
